<template>
   <div class="schmetterling-sales-report-page-container sub-page-wrapper">
      <Aside />
      <Main>
         <Navbar />
         <div class="container-fluid">
            <div class="row">
               <div class="col gts-box mx-3">
                  <h1 class="sub-page-header">
                     {{ $t("schmetterlingSalesReport_title") }}
                  </h1>
                  <div class="sub-page-row-wrapper row gy-3">
                     <div class="col-12 col-md-6 col-lg-2">
                        <UIDatePicker
                           :key="$i18n.locale"
                           :label="$t('schmetterlingSalesReport_filter_lblFromDate')"
                           :min="searchQuery.date1.min"
                           :max="searchQuery.date1.max"
                           lighter
                           v-model="searchQuery.date1.value" />
                     </div>
                     <div class="col-12 col-md-6 col-lg-2">
                        <UIDatePicker
                           :key="$i18n.locale"
                           :label="$t('schmetterlingSalesReport_filter_lblToDate')"
                           :min="searchQuery.date2.min"
                           :max="searchQuery.date2.max"
                           lighter
                           v-model="searchQuery.date2.value" />
                     </div>
                     <div class="col-12 col-md-6 col-lg-2">
                        <UIInput
                           :key="$i18n.locale"
                           :label="$t('schmetterlingSalesReport_filter_lblReservationNo')"
                           v-model="searchQuery.reservationNo"
                           :placeholder="$t('schmetterlingSalesReport_filter_plhReservationNo')"
                           lighter
                           v-input="{
                              type: 'alphanumeric',
                              len: [0, 20],
                              required: false,
                           }" />
                     </div>
                     <div class="col-12 col-md-6 col-lg-3">
                        <UISelectBox :key="$i18n.locale" :label="$t('schmetterlingSalesReport_filter_lblStatus')" :options="schmetterlingStatuses" v-model="searchQuery.schmetterlingStatus" lighter />
                     </div>
                  </div>

                  <div class="sub-page-actions-row row">
                     <div class="sub-pages-actions-wrapper col-12">
                        <UIButton className="default" :text="$t('common_list')" @click.native="listSchmetterlingSalesReport" />
                     </div>
                  </div>
               </div>
            </div>

            <template v-if="currentTableOptions.rows.length > 0">
               <section class="page-section gts-box">
                  <SmartTable :options="currentTableOptions" />
               </section>
               <section>
                  <UIModal ref="modelData" :title="$t('schmetterlingSalesReport_tblMain_btnModelData')">
                     <template>
                        <div class="model-data-content">
                           <ModelDataViewer :modelData="modelDataContent" />
                        </div>
                     </template>
                  </UIModal>
               </section>
            </template>
         </div>
      </Main>
   </div>
</template>

<script>
import moment from "moment";
import Popup from "@/gts-popup.js";
import Main from "@/components/unitary/Main.vue";
import Aside from "@/components/unitary/Aside.vue";
import { reportService } from "@/service/index.js";
import UIModal from "@/components/utils/Modal.vue";
import Navbar from "@/components/unitary/Navbar.vue";
import UIButton from "@/components/unitary/Button.vue";
import UIInput from "@/components/unitary/form2/UIInput.vue";
import UISelectBox from "@/components/unitary/form2/UISelectBox.vue";
import ModelDataViewer from "@/components/unitary/ModelDataViewer.vue";
import UIDatePicker from "@/components/unitary/form2/UIDatePicker2.vue";

export default {
   name: "SchmetterlingSalesReport",
   components: {
      Main,
      Aside,
      Navbar,
      UIInput,
      UIModal,
      UIButton,
      UISelectBox,
      UIDatePicker,
      ModelDataViewer,
   },

   data() {
      return {
         modelDataContent: {},
         searchQuery: {
            date1: {
               min: moment("2022-01-01").format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().format(this.$constants.dateFormat),
            },
            date2: {
               min: moment("2022-01-01").format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().format(this.$constants.dateFormat),
            },
            reservationNo: "",
            schmetterlingStatus: -1,
         },
         tableOptions: {
            columns: [],
            rows: [],
            rules: {
               autoMerge: ["orderId"],
               dominantCell: "reservationNo",
               showOnMobile: [0, 2, 4, 7],
            },
            options: {
               header: {
                  title: this.$options.name,
                  viewOptions: {
                     status: true,
                     perPage: 50,
                     selects: [
                        { name: `3 ${this.$t("common_order")}`, value: 3 },
                        { name: `5 ${this.$t("common_order")}`, value: 5 },
                        { name: `25 ${this.$t("common_order")}`, value: 25 },
                        { name: `50 ${this.$t("common_order")}`, value: 50 },
                        { name: `100 ${this.$t("common_order")}`, value: 100 },
                        { name: `${this.$t("common_all")}`, value: null },
                     ],
                  },
                  viewMode: "default",
               },
               footer: {
                  pagination: {
                     pages: [],
                     activepage: 1,
                  },
               },
            },
         },
      };
   },
   computed: {
      schmetterlingStatuses() {
         return this.$GtsDropdownData.ESchmetterlingOrderStatus(true);
      },
      tableColumns() {
         return [
            {
               label: this.$t("schmetterlingSalesReport_tblMain_thStatus"),
               status: true,
            },
            {
               label: this.$t("schmetterlingSalesReport_tblMain_thOrderDetail"),
               status: true,
            },
            {
               label: this.$t("schmetterlingSalesReport_tblMain_thReservationNo"),
               status: true,
               identifier: "reservationNo",
            },
            {
               label: this.$t("schmetterlingSalesReport_tblMain_thHotelName"),
               status: true,
            },
            {
               label: this.$t("schmetterlingSalesReport_tblMain_thCustomerNameSurname"),
               status: true,
            },
            {
               label: this.$t("schmetterlingSalesReport_tblMain_thTourOperator"),
               status: true,
            },
            {
               label: this.$t("schmetterlingSalesReport_tblMain_thCheckInDateTime"),
               status: true,
            },
            {
               label: this.$t("schmetterlingSalesReport_tblMain_thCheckOutDateTime"),
               status: true,
            },
            {
               label: this.$t("schmetterlingSalesReport_tblMain_thTotalPrice"),
               status: true,
            },
            {
               label: this.$t("schmetterlingSalesReport_tblMain_thOrderId"),
               status: true,
            },
         ];
      },
      currentTableOptions() {
         return { ...this.tableOptions, columns: this.tableColumns };
      },
   },
   methods: {
      listSchmetterlingSalesReport() {
         this.tableOptions.rows = [];

         this.$store.commit("app/setIsProgressGifActive", true);

         let request = {
            date1: this.searchQuery.date1.value + "T00:00:00",
            date2: this.searchQuery.date2.value + "T23:59:59",
            reservationNo: this.searchQuery.reservationNo == "" ? null : this.searchQuery.reservationNo,
            status: this.searchQuery.schmetterlingStatus,
         };

         reportService.schmetterlingSalesReport(request).then((res) => {
            if (!res.result.success) {
               res.result.service = this.$options.name;
               Popup.result(res.result);
               return;
            }

            if (res.result.success) {
               this.$store.commit("app/setIsProgressGifActive", false);

               res.items.map((item) => {
                  const rowObj = {
                     status: {
                        text: this.$options.filters.ESchmetterlingOrderStatus(item.status),
                        class: `schmetterling-badge gts-badge ESchmetterlingOrderStatus-${item.status}`,
                     },
                     orderDetail: () => {
                        if (item.modelData) {
                           return {
                              text: this.$t("schmetterlingSalesReport_btnDetail"),
                              class: "gts-badge smart-table-badge-1",
                              onClick: () => {
                                 this.modelDataContent = {};
                                 this.$refs.modelData.isModalOpen = true;
                                 this.modelDataContent = item.modelData;
                              },
                           };
                        } else {
                           return {
                              text: this.$t("schmetterlingSalesReport_btnDetailNotAvailable"),
                              class: "gts-btn gts-btn-default disabled",
                              url: null,
                           };
                        }
                     },
                     reservationNo: { text: item.reservationNo, class: "" },
                     hotelName: { text: item.hotelName, class: "" },
                     customerName: { text: item.customerName, class: "" },
                     tourOperator: { text: item.tourOperator, class: "" },
                     checkInDateTime: {
                        text: this.$options.filters.fullDateFormat(item.checkInDateTime),
                        class: "",
                     },
                     checkOutDateTime: {
                        text: this.$options.filters.fullDateFormat(item.checkOutDateTime),
                        class: "",
                     },
                     totalPrice: {
                        text: this.$options.filters.price(item.totalPrice),
                        class: "price-display",
                     },
                     orderId: { text: item.orderId === 0 ? "" : item.orderId, class: "" },
                  };
                  this.tableOptions.rows.push(rowObj);
               });
            }
         });
      },
   },
   watch: {
      "searchQuery.date1.value"(newDate1) {
         if (moment(newDate1, this.$constants.dateFormat).isAfter(moment(this.searchQuery.date2.value, this.$constants.dateFormat))) {
            this.searchQuery.date2.value = newDate1;
         }
      },
      "searchQuery.date2.value"(newDate2) {
         if (moment(newDate2, this.$constants.dateFormat).isBefore(moment(this.searchQuery.date1.value, this.$constants.dateFormat))) {
            this.searchQuery.date1.value = newDate2;
         }
      },
   },
};
</script>

<style lang="scss" scoped>
.page-container {
   .page-inner {
      width: 90%;
      margin: auto;
      .page-form-row {
         display: grid;
         grid-template-columns: repeat(6, 1fr);
         grid-column-gap: 1rem;
      }
      .page-action-row {
         margin-top: 1rem;
         display: flex;
         justify-content: flex-end;
      }
   }
}
.model-data-content {
   white-space: pre-wrap;
   word-break: break-all;
   font-family: monospace;
   font-size: 0.9rem;
   padding: 1rem;
   background-color: var(--gray-100);
   border-radius: 0.25rem;
}
.copy-clipboard-icon {
   cursor: pointer;
   filter: brightness(0) saturate(100%) invert(35%) sepia(52%) saturate(745%) hue-rotate(176deg) brightness(97%) contrast(97%);
}
::v-deep(.modal-content-wrapper) {
   height: 80%;
   width: 80%;
   overflow: auto;
}
</style>
